import {useMemo} from "react";

import {UserPhoneVerification as UserPhoneVerificationBase} from "@pg-mono/user";

import {ISmsLoginSendResult} from "../../../auth/api/sms_login";
import {PromotionSmsLoginProvider} from "../../../auth/providers/PromotionSmsLoginProvider";
import {
    trackAmplitudePhoneVerified,
    usePhoneVerificationAmplitudeContext,
    useTrackAmplitudePhoneVerifyModalView
} from "../../../user/tracking/track_amplitude_phone_verified";

const SMS_LOGIN_STORAGE_KEY_NAMESPACE = "promotionSmsLogin";

interface IProps {
    email: string;
    phone: string;
    initialSendResult: ISmsLoginSendResult;
    isOpen: boolean;
    onClose: () => void;
    onSuccess: () => void;
    onChangeNumber: () => void;
    onInitRejected: (error: {message: string; status: number}) => void;
}

export const PromotionLeadSmsLoginVerification = (props: IProps) => {
    const {email, phone, initialSendResult, isOpen, onClose, onSuccess, onChangeNumber, onInitRejected} = props;
    const credentials = useMemo(() => ({email, phone}), [email, phone]);
    const amplitudeContext = usePhoneVerificationAmplitudeContext("mainLead");

    useTrackAmplitudePhoneVerifyModalView(amplitudeContext);

    const handleClose = () => {
        trackAmplitudePhoneVerified(false, amplitudeContext);
        onClose();
    };

    return (
        <PromotionSmsLoginProvider
            credentials={credentials}
            initialSendResult={initialSendResult}
            onInitRejected={onInitRejected}
            amplitudeContext={amplitudeContext}
        >
            <UserPhoneVerificationBase
                isOpen={isOpen}
                onClose={handleClose}
                onSuccess={onSuccess}
                onChangeNumber={onChangeNumber}
                phoneNumber={phone}
                storageKeyNamespace={SMS_LOGIN_STORAGE_KEY_NAMESPACE}
                allowResendAfterTooManyRequests
                restartCooldownOnOpen
            />
        </PromotionSmsLoginProvider>
    );
};
import {useMemo} from "react";

import {UserPhoneVerification as UserPhoneVerificationBase} from "@pg-mono/user";

import {ISmsLoginSendResult} from "../../../auth/api/sms_login";
import {PromotionSmsLoginProvider} from "../../../auth/providers/PromotionSmsLoginProvider";
import {
    trackAmplitudePhoneVerified,
    usePhoneVerificationAmplitudeContext,
    useTrackAmplitudePhoneVerifyModalView
} from "../../../user/tracking/track_amplitude_phone_verified";

const SMS_LOGIN_STORAGE_KEY_NAMESPACE = "promotionSmsLogin";

interface IProps {
    email: string;
    phone: string;
    initialSendResult: ISmsLoginSendResult;
    isOpen: boolean;
    onClose: () => void;
    onSuccess: () => void;
    onChangeNumber: () => void;
    onInitRejected: (error: {message: string; status: number}) => void;
}

export const PromotionLeadSmsLoginVerification = (props: IProps) => {
    const {email, phone, initialSendResult, isOpen, onClose, onSuccess, onChangeNumber, onInitRejected} = props;
    const credentials = useMemo(() => ({email, phone}), [email, phone]);
    const amplitudeContext = usePhoneVerificationAmplitudeContext("mainLead");

    useTrackAmplitudePhoneVerifyModalView(amplitudeContext);

    const handleClose = () => {
        trackAmplitudePhoneVerified(false, amplitudeContext);
        onClose();
    };

    return (
        <PromotionSmsLoginProvider
            credentials={credentials}
            initialSendResult={initialSendResult}
            onInitRejected={onInitRejected}
            amplitudeContext={amplitudeContext}
        >
            <UserPhoneVerificationBase
                isOpen={isOpen}
                onClose={handleClose}
                onSuccess={onSuccess}
                onChangeNumber={onChangeNumber}
                phoneNumber={phone}
                storageKeyNamespace={SMS_LOGIN_STORAGE_KEY_NAMESPACE}
                allowResendAfterTooManyRequests
                restartCooldownOnOpen
            />
        </PromotionSmsLoginProvider>
    );
};
